<prox-main [parent]="this" [bodyTemplate]="bodyTemplate" [footerTemplate]="footerTemplate"></prox-main>

<ng-template #bodyTemplate>
  <prox-activation-checklist *ngIf="isValidateActivated" [activationErrors]="activationService.activateErrors"
    [entityName]="account.name" [activationService]="activationService"></prox-activation-checklist>
  <h5 *ngIf="!this.isValidateActivated" class="card-header">
    <div class="flex flex-row">
      <span *ngIf="!isBeingAdded">{{account.name}}</span>
      <span *ngIf="isBeingAdded">* New Account *</span>
      <span *ngIf="!isBeingAdded" class="qb-status-message">{{statusMessage()}}</span>
    </div>
  </h5>

  <div class="qb-content-card w-full h-fit">
    <div class="flex flex-col gap-4 qb-responsive-split">
      <!-- Row 1: Account details (w-1/2) + Status cards (edit mode) -->
      <div class="flex flex-row gap-4">
        <div class="qb-detail-card w-1/2 h-fit" *ngIf="isPageReady">
          <div class="card-body">
            <div class="flex">
              <div class="w-full pb-3 pr-3">
                <prox-field label="Account Name">
                  <input type="text" [disabled]="isReadOnly()" pInputText autocomplete="off" [pAutoFocus]="true"
                    [(ngModel)]="account.name" [bzModel]="account" name="name" />
                </prox-field>
              </div>
            </div>
            <div class="flex">
              <div class="w-1/3 pb-3 pr-3">
                <prox-field label="Start Date">
                  <p-datepicker [disabled]="!isBeingAdded" [(ngModel)]="account.startDate" [bzModel]="account"
                    name="startDate"></p-datepicker>
                </prox-field>
              </div>
              <div class="w-1/3 pb-3 pr-3">
                <prox-field label="Fiscal Start Month">
                  <p-select [options]="fiscalMonthNums" optionLabel="label" optionValue="value"
                    [(ngModel)]="fiscalMonthNum" (ngModelChange)="fiscalDateChanged()" name="fiscalMonthNum"
                    [disabled]="isReadOnly()" class="w-full"></p-select>
                </prox-field>
              </div>
              <div class="w-1/3 pb-3 pr-3">
                <prox-field label="Fiscal Start Day">
                  <p-select [options]="fiscalDayNums" optionLabel="label" optionValue="value" [(ngModel)]="fiscalDayNum"
                    (ngModelChange)="fiscalDateChanged()" name="fiscalDayNum" [disabled]="isReadOnly()"
                    class="w-full"></p-select>
                </prox-field>
              </div>
            </div>
            <div class="flex">
              <div class="w-2/3 pb-3 pr-3">
                <prox-field label="User Import Code Requirement">
                  <p-select [options]="importOptions" [(ngModel)]="account.accountImportCodeOptionId" optionValue="id"
                    [disabled]="isReadOnly()" optionLabel="name" placeholder="Choose Account User import requirement"
                    name="importOptions" class="w-full"></p-select>
                </prox-field>
              </div>
            </div>
            <div *ngIf="!isBeingAdded" class="flex">
              <div class="w-2/3 pb-3 pr-3">
                <prox-field label="Account User Access">
                  <div class="flex items-center gap-2">
                    <p-checkbox [(ngModel)]="account.allowAccountUserAccess" [bzModel]="account" [binary]="true"
                      [disabled]="isReadOnly()" name="allowAccountUserAccess"
                      inputId="allowAccountUserAccess"></p-checkbox>
                    <label for="allowAccountUserAccess">
                      Allow Account Users to log in and place their own orders
                    </label>
                  </div>
                </prox-field>
              </div>
            </div>
            <div *ngIf="!isBeingAdded" class="flex items-center">
              <div class="w-2/3 pb-3 pr-3">
                <prox-field label="Principal Account Administrator">
                  <p-select [options]="filterAccountAdmins" [(ngModel)]="account.primaryAccountAdminId" optionValue="id"
                    [disabled]="isReadOnly()" optionLabel="proximityUser.name"
                    placeholder="Select your Principal Account Administrator" name="accountAdmins"
                    class="w-full"></p-select>
                </prox-field>
              </div>
              <div class="mt-4">
                <p-button (click)="gotoAdministrator()" size="small" label="View"
                  [disabled]="disableViewAdministrator()"></p-button>
              </div>
            </div>
          </div>
        </div>
        <div *ngIf="!isBeingAdded" class="qb-info-cards w-1/5">
          <p-card header="Current Status" class="status-card">
            <h3 id="accountStatus">{{account.activeStatus.name}}</h3>
            <p-button size="small" (onClick)="toggleActivate()" label={{statusButtonLabel()}}
              [disabled]="!canEdit()"></p-button>
          </p-card>
          <p-card header="Current Fiscal Period" class="status-card">
            <h4>{{ currentFiscalPeriod }}</h4>
          </p-card>
        </div>
      </div>
      <!-- Row 2: Principal Account Administrator form (add mode only) -->
      <div *ngIf="isBeingAdded" class="flex flex-row gap-4">
        <div class="qb-detail-card w-2/3 h-fit">
          <h5 class="mb-2 font-semibold">Principal Account Administrator</h5>
          <prox-user-frm [proximityUser]="proximityUser" [isBeingAdded]="isBeingAdded" [roles]="allRoles"
            [autoFocus]="false"></prox-user-frm>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #footerTemplate>
  <prox-save-cancel [uow]="this" (undo)="onCancel()" (save)="onSave()" (cancel)="onCancel()"></prox-save-cancel>
</ng-template>